import { DashboardLayout } from "@layouts/index";
import CautionFeeSummary from "../../components/CautionFeeSummary";
import BankAccountCard from "../../components/BankAccountCard";
import CautionFeeSetup from "../../components/CautionFeeSetup";
import { CautionFeeTable } from "@shared/cards";
// import { compareAsc } from 'date-fns';
// import {invoices} from './data';
import notification from "../../assets/images/notifications.png";
import pinImg from "../../assets/images/pin2.png";
import { Fragment, useEffect, useState } from "react";
import {
  // LinkAccount,
  // getBankCodes,
  getWallet,
  getUnpaidCautionFees,
  getProfile,
  // saveAccount,
  sendOTP,
  validateOTP,
  withdrawFunds,
} from "@services/krent.service";
import { useSessionStorage } from "../../hooks";
import { Modal } from "@shared/controls/Modal";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import ktoast from "@services/toast.service";
import AddBankAccount from "components/AddBankAccount";
import { newFormatNumberWithCommas } from "@utils/helpers";
import { toast, ToastContainer } from "react-toastify";

// import {addBankAccountDetails} from './addBankAccountDetails';

interface WalletProps {
  balance: {
    available: number;
    book: number;
  };
  credits: number;
  currency: "NGN" | "USD";
  debits: number;
  disabled: boolean;
  id: string;
  paymentMethod: {
    accountName: string;
    accountNumber: string;
    accountType: "Current" | "Savings";
    bankName: string;
    sortCode: string;
  };
  user: {
    id: string;
    role: string;
  };
}

// type Bank = {
//   active: boolean;
//   code: string;
//   country: string;
//   createdAt: string;
//   currency: string;
//   gateway: string;
//   id: number;
//   is_deleted: boolean;
//   longcode: string;
//   name: string;
//   pay_with_bank: boolean;
//   slug: string;
//   type: string;
//   updatedAt: string;
// };
export type Bank = {
  value: string;
  label: string;
};

export const Wallet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useSessionStorage("user", {});
  const [loading, setLoading] = useState<boolean>(false);
  const [working, setWorking] = useState<boolean>(false);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [isWithdrawModal, setWithrawalModal] = useState<boolean>(false);
  const [modalSize, setModalSize] = useState<"lg" | "md" | "sm" | number>("lg");
  const [isEditAccountModalOpen, openEditAccountModal] =
    useState<boolean>(false);
  const [isOtpSent, setOtpSent] = useState<boolean>(false);
  const [otpError, setOtpError] = useState<boolean>(false);
  const [isPinRequired, setPinRequired] = useState<boolean>(false);
  const [isVerifying, setIsVerifiying] = useState<boolean>(false);
  const [wallet, setWallet] = useState<WalletProps>();
  const [unpaidCautionFees, setUnpaidCautionFees] = useState<any>([]);
  const [cautionFeePagination, setCautionFeePagination] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;
  const [cautionFeeIntent, setCautionFeeIntent] = useState<
    "shortlet" | "long-lease"
  >("shortlet");
  const [showAddBank, setShowAddBank] = useState(false);
  const [isChangeRequest, setIsChangeRequest] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hasPin, setHasPin] = useState<boolean>(Boolean(user?.hasPIN));
  const [withdrawalAmount, setWithdrawalAmount] = useState<string>();
  const [showWithdrawalPin, setShowWithdrawalPin] = useState<boolean>(false);
  const [withdrawalLoading, setWithdrawalLoading] = useState<boolean>(false);
  const [withdrawalError, setWithdrawalError] = useState<string>("");

  // fetch wallet function
  const fetchWallet = () => {
    setLoading(true);
    const { wallet: walletID } = user;
    let abortController = new AbortController();
    if (walletID) {
      getWallet(walletID, abortController.signal)
        .then((res: any) => {
          // console.log(res, "resss");
          setWallet(res.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setModalOpen(true);
    }
    return () => {
      abortController.abort();
      setModalOpen(false);
    };
  };

  const handleVerifyOTP = () => {
    const code = Array.prototype.map
      .call(document.getElementsByClassName("digits"), (e) => e.value)
      .join("");
    let abortController = new AbortController();
    setIsVerifiying(true);
    validateOTP({ otp: code }, abortController.signal)
      .then(() => {
        setPinRequired(true);
      })
      .catch(() => {
        setOtpError(true);
        toast.error("Failed to validate OTP");
      })
      .finally(() => {
        setIsVerifiying(false);
      });
  };

  const handleCloseAccountModal = (success = false) => {
    setShowAddBank(false);
    fetchWallet();
    if (success) {
      setShowSuccessModal(true);
    }
  };

  const submitWithdrawalRequest = () => {
    setWithdrawalLoading(true);
    // e.preventDefault();
    let abortController = new AbortController();
    const code = Array.prototype.map
      .call(document.getElementsByClassName("digits"), (e) => e.value)
      .join("");
    withdrawFunds(
      {
        id: user.wallet,
        data: {
          amount: withdrawalAmount,
          pin: code,
        },
      },
      abortController.signal,
    )
      .then((resp: any) => {
        if (resp.errors) {
          toast.error(resp.errors[0].message);
          setWithdrawalError(resp.errors[0].message);
          return;
        }
        if (resp.success) {
          setWithdrawalAmount("");
          fetchWallet();
          toast.success(resp?.message);
          setWithrawalModal(false);
        }
      })
      .catch((err) => {
        setShowWithdrawalPin(false);
        toast.error(err.errors[0].message);
        setWithdrawalError(err.errors[0].message);
      })
      .finally(() => {
        setWithdrawalLoading(false);

        // Clear input values after successful submission
        const digitsInputs = document.getElementsByClassName("digits");
        for (let i = 0; i < digitsInputs.length; i++) {
          (digitsInputs[i] as HTMLInputElement).value = "";
        }
      });
  };
  const handleKeyDown = (e: any, currentInputId: string) => {
    if (e.key === "Backspace" && e.target.value === "") {
      const previousInputId = getPreviousInputId(currentInputId);
      if (previousInputId) {
        document.getElementById(previousInputId)!.focus();
      }
    }
  };

  const getPreviousInputId = (currentInputId: string) => {
    // Define the order of  input fields
    const inputOrder = ["first", "second", "third", "fourth"];
    const currentIndex = inputOrder.indexOf(currentInputId);

    // Check if the current input is not the first input
    if (currentIndex > 0) {
      return inputOrder[currentIndex - 1];
    }

    return null; // If there's no previous input
  };

  useEffect(() => {
    setHasPin(Boolean(user?.hasPIN));
  }, [user?.hasPIN]);

  useEffect(() => {
    const abortController = new AbortController();
    getProfile(abortController.signal)
      .then((res: any) => {
        if (res?.data) {
          setUser(res.data);
          setHasPin(Boolean(res.data.hasPIN));
        }
      })
      .catch((err) => {
        console.log(err);
      });
    return () => {
      abortController.abort();
    };
  }, [setUser]);

  useEffect(() => {
    fetchWallet();
  }, [user]);

  // console.log(user, 'po');

  useEffect(() => {
    const { wallet: walletID } = user;

    let abortController = new AbortController();

    if (walletID) {
      setLoading(true);
      getUnpaidCautionFees(
        abortController.signal,
        currentPage,
        perPage,
        cautionFeeIntent,
      )
        .then((res: any) => {
          setUnpaidCautionFees(res.data);
          setCautionFeePagination(res.pagination);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    return () => {
      abortController.abort();
    };
  }, [user, currentPage, perPage, cautionFeeIntent]);

  useEffect(() => {
    if (
      location.state &&
      (location.state as any).flow === "messaging-payment"
    ) {
      if (wallet?.paymentMethod?.accountNumber) {
        navigate((location.state as any).from, { replace: true });
      }
    }
  }, [location.state, wallet, navigate]);

  useEffect(() => {
    const inputs = document.querySelectorAll<HTMLInputElement>("#otp > *[id]");

    const autoFocus = (
      event: React.KeyboardEvent<HTMLInputElement>,
      i: number,
    ) => {
      if (event.key === "Backspace") {
        inputs[i].value = "";
        if (i !== 0) inputs[i - 1].focus();
      } else {
        if (i === inputs.length - 1 && inputs[i].value !== "") {
          return true;
        } else if (event.keyCode > 47 && event.keyCode < 58) {
          inputs[i].value = event.key;
          if (i !== inputs.length - 1) inputs[i + 1].focus();
          event.preventDefault();
        } else if (event.keyCode > 64 && event.keyCode < 91) {
          inputs[i].value = String.fromCharCode(event.keyCode);
          if (i !== inputs.length - 1) inputs[i + 1].focus();
          event.preventDefault();
        }
      }
    };

    if (isOtpSent) {
      for (let i: number = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("keydown", () => autoFocus);
      }
    }

    return () => {
      const inputs =
        document.querySelectorAll<HTMLInputElement>("#otp > *[id]");
      for (let i: number = 0; i < inputs.length; i++) {
        inputs[i].removeEventListener("keydown", () => autoFocus);
      }
    };
  }, [isOtpSent]);

  const generateWallet = () => {
    setWorking(true);
    let abortController = new AbortController();
    sendOTP(abortController.signal)
      .then(() => {
        // console.log(res);
        setOtpSent(true);
      })
      .then(() => {})
      .finally(() => {
        setWorking(false);
      });
  };

  const handlePinSave = (_pin: string) => {
    const updatedUser = { ...user, hasPIN: true };
    setUser(updatedUser);
    setHasPin(true);
    setShowAddBank(true);
  };

  return (
    <>
      {!hasPin ? (
        <CautionFeeSetup onSave={handlePinSave} />
      ) : (
        <DashboardLayout
          title="Caution fee"
          subtitle="Manage &amp; receive payments on your account"
        >
          <ToastContainer limit={1} />

          <BankAccountCard
            wallet={wallet}
            loading={loading}
            onLinkAccount={() => {
              setIsChangeRequest(false);
              setShowAddBank(true);
            }}
            onChangeAccount={() => {
              setIsChangeRequest(true);
              setShowAddBank(true);
            }}
          />
          {/* <div className="col-12 col-md-5 mb-3 mb-md-0">
        <div className="card border-0 shadow-sm border-round h-full pb-0">
          <div className="p-4">
            <h6 className="fs-14 mt-1">Available Wallet Balance</h6>
            <h3 className="fw-bolder mt-2">
              {wallet?.currency}{" "}
              {wallet?.balance?.available?.toLocaleString() || "NGN 0.00"}
            </h3>
            <h3 className="fs-12 mt-2">
              Book Balance - {} NGN{" "}
              {wallet?.balance?.book?.toLocaleString() || "NGN 0.00"}{" "}
              <Tippy
                className="custom-tippy"
                content="Your book balance represents the total unclaimed caution fee."
              >
                <i className="iconly-Info-Circle icli mr-1 ml-1 fs-13"></i>
              </Tippy>
            </h3>
          </div>

          {wallet && wallet?.balance?.available > 0 && (
            <button
              className="btn btn-primary rounded-4 rounded-top-left-0 rounded-top-right-0"
              onClick={() => setWithrawalModal(true)}
            >
              Withdraw Funds
            </button>
          )}
        </div>
      </div> */}

          <div className="row mt-5 mt-md-2">
            <div className="col-12">
              <CautionFeeSummary />
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 gap-3 flex flex-col">
              <h5 className="fw-600">Caution fees</h5>

              {/* Intent tabs */}
              <div
                className="d-flex gap-2 mb-3"
                style={{ borderBottom: "2px solid #e5e7eb" }}
              >
                {(["shortlet", "long-lease"] as const).map((tab) => (
                  <button
                    key={tab}
                    type="button"
                    onClick={() => {
                      setCautionFeeIntent(tab);
                      setCurrentPage(1);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      padding: "0.5rem 1.25rem",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                      borderBottom:
                        cautionFeeIntent === tab
                          ? "2px solid var(--primary-color)"
                          : "2px solid transparent",
                      color:
                        cautionFeeIntent === tab
                          ? "var(--primary-color)"
                          : "#6b7280",
                      marginBottom: "-2px",
                      transition: "color 0.2s, border-color 0.2s",
                    }}
                  >
                    {tab === "shortlet" ? "Shortlet" : "Rent"}
                  </button>
                ))}
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <span
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                  />
                </div>
              ) : unpaidCautionFees?.length > 0 ? (
                <CautionFeeTable
                  showBookingType={cautionFeeIntent === "shortlet"}
                  data={unpaidCautionFees}
                  pagination={cautionFeePagination}
                  onPageChange={setCurrentPage}
                />
              ) : (
                <div className="card border-0 border-round p-5 text-center d-flex align-items-center">
                  <h6 className="fs-18 mt-1 fw-bold mb-4">
                    No caution fees yet
                  </h6>
                  <img src={notification} alt="No transactions" width={200} />
                  <p className="fs-14 light-text">
                    Any{" "}
                    {cautionFeeIntent === "shortlet"
                      ? "shortlet"
                      : "long-lease"}{" "}
                    caution fees will show here.
                  </p>
                </div>
              )}
            </div>
          </div>

          <Modal
            show={isModalOpen}
            onClose={() => setModalOpen(false)}
            dismissible={false}
          >
            {!isOtpSent ? (
              <div className="text-center">
                <p className="fs-14">
                  <span className="fw-bold">Oops!</span> You do not have a
                  wallet set up yet, Let's get you started.
                </p>
                <img
                  src={notification}
                  alt="No Wallet"
                  className="img-fluid my-3"
                  width="150"
                  height="150"
                />
                <div className="d-grid gap-2 col-6 mx-auto">
                  <button
                    className="btn btn-outline-dark rounded-pill px-5 py-3 fw-bolder fs-14"
                    onClick={generateWallet}
                  >
                    {working ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <span>Get Started</span>
                    )}
                  </button>
                  <Link
                    to="#"
                    onClick={() => navigate(-1)}
                    className="btn btn-link fs-12"
                  >
                    Go Back
                  </Link>
                </div>
              </div>
            ) : (
              <div className="container height-100 d-flex justify-content-center align-items-center">
                <div className="position-relative">
                  <div className="px-2 text-center">
                    <p className="fs-16">
                      Please enter the one time password to verify your account
                    </p>
                    <p className="fs-14">
                      A code has been sent to{" "}
                      <span className="fw-bold">
                        *******{user?.phone.slice(-4)}
                      </span>
                    </p>
                    <div
                      id="otp"
                      className={`inputs d-flex flex-row justify-content-center mt-2${
                        otpError ? " invalid-otp" : ""
                      }`}
                    >
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded digits"
                        type="text"
                        id="first"
                        maxLength={1}
                        onFocus={() => setOtpError(false)}
                        onChange={(e) => {
                          if (e.target.value) {
                            document!.getElementById("second")!.focus();
                          }
                        }}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded digits"
                        type="text"
                        id="second"
                        maxLength={1}
                        onChange={(e) => {
                          if (e.target.value) {
                            document!.getElementById("third")!.focus();
                          }
                        }}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded digits"
                        type="text"
                        id="third"
                        maxLength={1}
                        onChange={(e) => {
                          if (e.target.value) {
                            document!.getElementById("fourth")!.focus();
                          }
                        }}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded digits"
                        type="text"
                        id="fourth"
                        maxLength={1}
                        onChange={(e) => {
                          if (e.target.value) {
                            document!.getElementById("fifth")!.focus();
                          }
                        }}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded digits"
                        type="text"
                        id="fifth"
                        maxLength={1}
                        onChange={(e) => {
                          if (e.target.value) {
                            document!.getElementById("sixth")!.focus();
                          }
                        }}
                      />
                      <input
                        className="m-2 py-4 px-3 text-center form-control rounded digits"
                        type="text"
                        id="sixth"
                        maxLength={1}
                      />
                    </div>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary rounded-pill px-5 py-2"
                        onClick={handleVerifyOTP}
                      >
                        Validate
                      </button>
                    </div>
                  </div>
                  <div className="mt-3 text-center">
                    <div className="content d-flex justify-content-center align-items-center">
                      <button
                        disabled={isVerifying}
                        className="btn btn-link fs-14 text-decoration-none"
                        onClick={generateWallet}
                      >
                        Didn't get the code?{" "}
                        <span className="text-dark">Resend</span>
                      </button>
                    </div>
                    <button
                      onClick={() => setOtpSent(false)}
                      className="btn btn-link fs-12"
                    >
                      Go Back
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Modal>

          <Modal
            id="openEdit"
            show={isEditAccountModalOpen}
            onClose={() => {
              openEditAccountModal(false);
              setModalSize("lg");
              setPinRequired(false);
            }}
            size={modalSize}
          >
            {isPinRequired ? (
              <div
                className="container height-100 d-flex justify-content-center align-items-center"
                style={{ width: 350 }}
              >
                <div className="position-relative">
                  <div className="px-2 text-center">
                    <p className="fs-16 fw-600">
                      Please enter your 4-digit pin to authorize
                    </p>
                    <div
                      id="otp"
                      className="inputs d-flex flex-row justify-content-center mt-2"
                    >
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded"
                        type="text"
                        id="first"
                        maxLength={1}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded"
                        type="text"
                        id="second"
                        maxLength={1}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded"
                        type="text"
                        id="third"
                        maxLength={1}
                      />
                      <input
                        className="m-2 py-3 px-3 text-center form-control rounded"
                        type="text"
                        id="fourth"
                        maxLength={1}
                      />
                    </div>
                    <div className="my-4">
                      <button className="btn btn-primary rounded-pill px-5 py-2">
                        Authorize
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="container">
                <form className="px-4 pb-5">
                  <p className="fw-bold fs-20 mb-3">Payments</p>

                  <div className="row">
                    <div className="mb-4 col-md-6 col-12">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label fs-14 fw-600"
                      >
                        Bank name
                      </label>
                      <select
                        className="form-select rounded-pill py-2 px-4"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      >
                        <option>Guarantee trust bank (GTB)</option>
                      </select>
                    </div>

                    <div className="mb-4 col-md-6 col-12">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label fs-14 fw-600"
                      >
                        Account Number
                      </label>
                      <input
                        className="form-control rounded-pill py-2 px-4"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-5 col-md-6 col-12">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label fs-14 fw-600"
                      >
                        Account Name
                      </label>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setModalSize("md");
                      setPinRequired(true);
                    }}
                    className="btn btn-primary rounded-pill py-3 px-5 fw-bold fs-14"
                  >
                    Save Bank Account
                  </button>
                </form>
              </div>
            )}
          </Modal>

          <AddBankAccount
            id={user?.wallet}
            type="personal"
            show={showAddBank}
            onClose={() => handleCloseAccountModal(false)}
            onAccountSaved={() => handleCloseAccountModal(true)}
            previousLocation={location.pathname + location.search}
            isChangeRequest={isChangeRequest}
          />

          {/* Success Modal */}
          <Modal
            show={showSuccessModal}
            onClose={() => setShowSuccessModal(false)}
            size={600}
            className="modal-rounded"
          >
            <div className="text-center p-2">
              <div
                className="d-flex justify-content-center mb-4"
                style={{
                  width: 80,
                  height: 80,
                  background: "#edf7f4",
                  borderRadius: "50%",
                  margin: "0 auto",
                  alignItems: "center",
                }}
              >
                <svg
                  width="81"
                  height="81"
                  viewBox="0 0 81 81"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="80"
                    height="80"
                    rx="40"
                    fill="#0F5132"
                    fillOpacity="0.1"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="80"
                    height="80"
                    rx="40"
                    stroke="white"
                    strokeOpacity="0.4"
                  />
                  <path
                    d="M35.1861 56.9389L32.212 51.9264L26.5645 50.6889L27.1157 44.8751L23.2891 40.4968L27.1157 36.1184L26.5645 30.3047L32.212 29.0672L35.1861 24.0547L40.5003 26.3109L45.8145 24.0547L48.7886 29.0672L54.4361 30.3047L53.8849 36.1184L57.7116 40.4968L53.8849 44.8751L54.4361 50.6889L48.7886 51.9264L45.8145 56.9389L40.5003 54.6826L35.1861 56.9389ZM36.2503 53.7468L40.5003 51.9455L44.8016 53.7468L47.167 49.7468L51.7503 48.6955L51.3336 43.9968L54.417 40.4968L51.3336 36.9455L51.7503 32.2468L47.167 31.2468L44.7503 27.2468L40.5003 29.048L36.1991 27.2468L33.8336 31.2468L29.2503 32.2468L29.667 36.9455L26.5836 40.4968L29.667 43.9968L29.2503 48.7468L33.8336 49.7468L36.2503 53.7468ZM38.7503 45.8364L47.5899 36.9968L45.8336 35.1893L38.7503 42.2726L35.167 38.7405L33.4107 40.4968L38.7503 45.8364Z"
                    fill="#0F5132"
                  />
                </svg>
              </div>
              <h4 className="fw-bold mb-3">Bank details successful</h4>
              <p className="mb-4">
                Your bank details has been stored successfully. Please note that
                all payment will be made to this account. Kindly ensure that it
                is accurate. If not, you may request to change it
              </p>
              <div className="w-max ml-auto">
                <button
                  className="btn btn-primary rounded-4 px-5 py-3"
                  onClick={() => setShowSuccessModal(false)}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            id="openWithdraw"
            show={isWithdrawModal}
            onClose={() => {
              setWithrawalModal(false);
              setWithdrawalError("");
              setShowWithdrawalPin(false);
            }}
          >
            <div className="container">
              {!showWithdrawalPin && (
                <Fragment>
                  <p className="fs-22 fw-bold text-center">Withdraw</p>
                  <p className="text-end text-center fs-14">
                    Your Balance: {wallet?.currency}{" "}
                    {wallet?.balance?.available?.toLocaleString() || "NGN 0.00"}
                  </p>

                  <div className="input-group mb-3">
                    <input
                      className="form-control fs-1 mb-2 border-0 bg-light"
                      type="text"
                      placeholder="0.00"
                      value={newFormatNumberWithCommas(withdrawalAmount || "")}
                      onChange={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        if (/^\d*\.?\d*$/.test(raw)) {
                          setWithdrawalAmount(raw);
                        }
                      }}
                    />
                    <span
                      className="input-group-text border-0 bg-transparent"
                      id="basic-addon2"
                    >
                      {wallet?.currency}
                    </span>
                  </div>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      type="button"
                      className="fs-12 btn btn-link mb-3 p-0 text-decoration-none"
                      onClick={() =>
                        setWithdrawalAmount(
                          wallet?.balance?.available?.toString(),
                        )
                      }
                    >
                      Withdraw max
                    </button>
                  </div>
                  <div className="d-flex justify-content-between mb-4">
                    <div>
                      <p className="fw-bold fs-14">Withdrawing to: </p>
                    </div>
                    <div>
                      {wallet?.paymentMethod ? (
                        <Fragment>
                          <p className="mb-1 fs-12">
                            {wallet?.paymentMethod?.bankName}
                          </p>
                          <p className="mb-1 fs-12">
                            {wallet?.paymentMethod?.accountName}
                          </p>
                          <p className="mb-1 fs-12">
                            {wallet?.paymentMethod?.accountNumber}
                          </p>
                        </Fragment>
                      ) : (
                        <p>No Payment Method Selected</p>
                      )}
                    </div>
                  </div>
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => setShowWithdrawalPin(true)}
                    >
                      Continue
                    </button>
                  </div>
                </Fragment>
              )}

              {showWithdrawalPin && (
                <div
                  className="container height-100 d-flex justify-content-center align-items-center"
                  style={{ width: 350 }}
                >
                  <div className="position-relative">
                    <div className="px-2 text-center">
                      <p className="fs-16 fw-600">
                        Please enter your 4-digit pin to authorize
                      </p>
                      {withdrawalError && (
                        <p className="text-danger">{withdrawalError}</p>
                      )}
                      <div
                        id="otp"
                        className={`inputs d-flex flex-row justify-content-center mt-2${
                          otpError ? " invalid-otp" : ""
                        }`}
                      >
                        <input
                          className="m-2 py-3 px-3 text-center form-control rounded digits"
                          type="password"
                          id="first"
                          maxLength={1}
                          onFocus={() => setOtpError(false)}
                          onKeyDown={(e) => handleKeyDown(e, "first")}
                          onChange={(e) => {
                            if (e.target.value) {
                              document!.getElementById("second")!.focus();
                            }
                          }}
                        />
                        <input
                          className="m-2 py-3 px-3 text-center form-control rounded digits"
                          type="password"
                          id="second"
                          maxLength={1}
                          onKeyDown={(e) => handleKeyDown(e, "second")}
                          onChange={(e) => {
                            if (e.target.value) {
                              document!.getElementById("third")!.focus();
                            }
                          }}
                        />
                        <input
                          className="m-2 py-3 px-3 text-center form-control rounded digits"
                          type="password"
                          id="third"
                          maxLength={1}
                          onKeyDown={(e) => handleKeyDown(e, "third")}
                          onChange={(e) => {
                            if (e.target.value) {
                              document!.getElementById("fourth")!.focus();
                            }
                          }}
                        />
                        <input
                          className="m-2 py-3 px-3 text-center form-control rounded digits"
                          type="password"
                          id="fourth"
                          maxLength={1}
                          onKeyDown={(e) => handleKeyDown(e, "fourth")}
                          // onChange={(e) => {
                          //   if (e.target.value) {
                          //     document!.getElementById('fifth')!.focus();
                          //   }
                          // }}
                        />
                        {/* <input
                      className='m-2 py-3 px-3 text-center form-control rounded digits'
                      type='text'
                      id='fifth'
                      maxLength={1}
                      onChange={(e) => {
                        if (e.target.value) {
                          document!.getElementById('sixth')!.focus();
                        }
                      }}
                    />
                    <input
                      className='m-2 py-4 px-3 text-center form-control rounded digits'
                      type='text'
                      id='sixth'
                      maxLength={1}
                    /> */}
                      </div>
                      <div className="my-4">
                        <button
                          className="btn btn-primary rounded-pill px-5 py-2"
                          disabled={withdrawalLoading}
                          onClick={submitWithdrawalRequest}
                        >
                          {withdrawalLoading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Authorize"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Modal>
          <Modal
            id="hasPin"
            show={!hasPin}
            onClose={() => setHasPin(false)}
            dismissible={false}
          >
            <div className="text-center">
              <p className="fs-14">
                <span className="fw-bold">Oops!</span> You are yet to set your
                transaction pin.
              </p>
              <img
                src={pinImg}
                alt="No Wallet"
                className="img-fluid my-3"
                width="150"
                height="150"
              />
              <div className="d-grid gap-2 col-6 mx-auto">
                <Link
                  to="/settings?tab=pin"
                  state={{
                    from: location.pathname + location.search,
                  }}
                  className="btn btn-outline-dark rounded-pill px-5 py-3 fw-bolder fs-14"
                >
                  Set Now
                </Link>
                <Link
                  to="#"
                  onClick={() => navigate(-1)}
                  className="btn btn-link fs-12"
                >
                  Go Back
                </Link>
              </div>
            </div>
          </Modal>
        </DashboardLayout>
      )}
    </>
  );
};
